// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fu5wPeEeY19JO5Ykvtt9 {
    align-items: center;
    background-color: var(--background);
    display: flex;
    height: 66px;
    justify-content: space-between;
    padding: 20px 40px;
    width: 100%;
    z-index: var(--sidebar);
}

.bQa_fAmZf1KDuNsNogB_ {
    height: 100%;
    display: flex;
    align-items: center;

    position: relative;
}

.f_HStgEbqF8uEoloYc5g {
    color: var(--white);
    padding: 15px;
    height: 40px;
    width: 457px;
    border-radius: 5px;
    border: 1px solid var(--white);

    background-color: var(--black);
    font-size: 1rem;
    outline: none;
}

.XMTRqCU4Jr92kTqOxDgI {
    background-color: var(--red);
    height: 40px;
    width: 40px;
    border-radius: 0 5px 5px 0;
    right: 0;
    position: absolute;

}

input::placeholder {
    color: var(--white);
    font-size: 1rem;

}

input:focus {
    outline: none;
}

@media screen and (max-width: 1239px) {
    .fu5wPeEeY19JO5Ykvtt9::after {
        width: calc(100% - var(--width-tablet-sidebar));
    }
    .fu5wPeEeY19JO5Ykvtt9 {
        padding: 15px 20px;
        position: relative;
        height: 60px;
    }
    
}

.wUkz9Q3hUWnLgBdhdOHW img {
    width: 30px;
    height: 30px;
}

/* .logo {
    height: 100%;
    justify-content: center;
    display: flex;
    line-height: 30px;
}  */

.VJP9lm7KKyFsMjoSw_Ti img{
    height: 24px;
}


.KG8t9r0EQtTkcWJvrR3h {
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    justify-content: center;
}

.KG8t9r0EQtTkcWJvrR3h li {
    position: relative;

    display: flex;
    flex-direction: row;
    align-items: center;

    &:not(:last-child) {
        &:after {
            content: '';
            display: block;
            width: 1px;
            background-color: var(--disabled-c);
            margin-left: 20px;
            height: 28px;
        }
    }
}

/* .separator {
    border-right: 1px solid #ffffff;
    height: 18px;
    margin: 0 10px;
} */


.fu5wPeEeY19JO5Ykvtt9:has(.V4XMHjEUPMsytMfTBauu:only-child) {
    justify-content: center;
}

/* .icon {
    background-color: #000000;
    height: 50px;

} */

/* --------Contacts---------- */

.GAyIo3_TQQzadlwNe9a4 {
    position: relative;
}

.Pe_Qka6g65LnVGsMOBcr {
    display: block;
    height: max-content;
    width: max-content;
    position: absolute;
    top: 35px;
    right: -18px;
    background-color: #ffffff;
    border: 1px solid var(--red);
    border-radius: 5px;
    padding: 10px;
    animation: OCsXhj9eqh9SMfOD_AwG 0.5s ease-in;
    z-index: var(--cross);
}

.GAyIo3_TQQzadlwNe9a4 .Pe_Qka6g65LnVGsMOBcr {
    right: -25px;
    padding: 1.2vw;
}

.Pe_Qka6g65LnVGsMOBcr li {
    color: black;
}

.kzaDABW_0ZVDZmc9g59c {
    /*font-size: 12px;*/
    margin: 16px;
    text-align: center;
}


.Pe_Qka6g65LnVGsMOBcr a {
    color: #000000;
}

.Pe_Qka6g65LnVGsMOBcr:before {
    content: "";
    position: absolute;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid var(--red);
    right: 20px;
    top: -10px;
}

.Pe_Qka6g65LnVGsMOBcr:after {
    content: "";
    position: absolute;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid white;
    right: 20px;
    top: -8px;
}

.GAyIo3_TQQzadlwNe9a4 li {
    padding: 5px 0;
}

.GAyIo3_TQQzadlwNe9a4 li:not(:last-child) {
    border-bottom: 1px solid rgba(231, 49, 39, 0.4);
}

.Yy22RLA6hpl904go6A7c {
    text-align: left;
    padding: 15px;
    color: var(--black);
    width: 100%;
    font-size: 12px;
    line-height: 1.5;
    margin-bottom: 5px;
}

.Yy22RLA6hpl904go6A7c:disabled {
    color: var(--black);
    background-color: var(--ghost-white);
    border: none;
    cursor: default;

}

/* .account_btn:hover {
    background-color: var(--disabled-bg);
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1);
} */
.DUPVMUlR_DCmNkLUSeFh:hover {
    background-color: var(--disabled-bg);
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1);
}

.Yy22RLA6hpl904go6A7c > p {
    color: var(--dark-gray);
    font-size: 14px;
}
/* .account_btn {
    span {
        font-size: 10px;
        display: inline-block;
        color: var(--roman-silver);
        width: 100px;
        margin-left: -110px;
        margin-right: 7px;
    }
} */

.uwn83KQPrGSWGKByu_ag {
    position: absolute;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    z-index: var(--modal-layer);
}

.hZ3lEAhTpIU8uUCoxuaR {
    position: absolute;
    right: 39px;
    top: 70px;
    height: max-content;
    width: max-content;

    background-color: var(--white);
    border-radius: 10px;
    box-shadow: 0px 4px 16px 0px rgba(141, 155, 184, 0.2);
    /* padding: 15px 20px 20px 20px; */
    font-size: 12px;
    font-family: 'Mulish', sans-serif;
}


/* ------------------------------ */

@keyframes OCsXhj9eqh9SMfOD_AwG {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    50% {
        opacity: 1;
        transform: translateY(0px);
    }
}


.GAyIo3_TQQzadlwNe9a4 button {
    transition: transform .2s ease-in-out;
}


@media screen and (max-width: 1239px) {
    .KG8t9r0EQtTkcWJvrR3h li {
        &:not(:last-child) {
            &:after {
                margin-left: 6px;
                height: 26px;
            }
        }
    }
}


@media screen and (max-width: 767px) {
    .fu5wPeEeY19JO5Ykvtt9 {
        padding: 13px 20px;
        position: relative;
        height: 50px;
    }

    .fu5wPeEeY19JO5Ykvtt9::after {
        width: 100%;
        left: 0;
    }

    .KG8t9r0EQtTkcWJvrR3h {
        gap: 10px;
        z-index: var(--modal-layer);
        position: relative;
    }

    .VJP9lm7KKyFsMjoSw_Ti {height: 100%;} 
    .VJP9lm7KKyFsMjoSw_Ti img {
        height: 24px;
        width: auto;
    }
    
    /* .separator {
        margin: 0 5px;
    } */

    .v57lTLlGvUxxurhULUaw {
        padding: 10px 20px;
    }

    .wUkz9Q3hUWnLgBdhdOHW {
        img {
            width: 27px;
        }

        z-index: var(--over-modal);
    }

    .uwn83KQPrGSWGKByu_ag {
        position: absolute;
        left: 0;
        top: 0;
        height: 100vh;
        width: 100vw;
        z-index: var(--modal-layer);
        background-color: rgba(126, 150, 191, 0.6);
        
    }

    .hZ3lEAhTpIU8uUCoxuaR {
        position: absolute;
        left: 0;
        top: 50px;
        height: max-content;
        width: calc(100% - 40px);
        background-color: var(--white);
        border-radius: 10px;
        /* box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px; */
        margin: 0 20px;
        /* padding: 15px 20px 20px 20px; */
        font-size: 12px;
        font-family: 'Mulish', sans-serif;
    }

}

@media screen and (max-device-width: 470px) {
    .KG8t9r0EQtTkcWJvrR3h {
        gap: 6px;
    }
}

.QCnYunaonDzpGiXIVKGw {
    min-width: 24px;
    height: 24px;
    display: flex;
    gap: 2px;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 1px solid black;
    margin-left: 20px;
    div {
        height: 3px;
        width: 3px;
        background-color: #000000;
        border-radius: 50%;
    }
}

.QCnYunaonDzpGiXIVKGw:hover {
    background-color: var(--blue);
    border: 1px solid var(--blue);

    div {
        background-color: #ffffff;

    }
}

.yKnaWNK8TqJFHIJdGtg3 {
    width: 24px;
    height: 24px;
    display: flex;
    gap: 2px;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background-color: var(--blue);

    border: 1px solid var(--blue);
    margin-left: 20px;
    div {
        height: 3px;
        width: 3px;
        background-color: #fff;
        border-radius: 50%;
    }
}
@media screen and (max-width: 767px) {
    .yKnaWNK8TqJFHIJdGtg3, .QCnYunaonDzpGiXIVKGw {
        margin-left: 5px;

    }
}

.z3XYrQQiWN_spfpuOsVy {
    background: var(--blue);
    border-radius: 50%;
    background-size: cover;
    height: 35px;
    line-height: 35px;
    text-align: center;
    width: 35px;
    color: #fff;
}
.rOr3vTmHw3uLy4VUwAJz {
    background: var(--sidebar-hover);
    border-radius: 50%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Header.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;;IAEnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;;IAE9B,8BAA8B;IAC9B,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,QAAQ;IACR,kBAAkB;;AAEtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;;AAEnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,+CAA+C;IACnD;IACA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,YAAY;IAChB;;AAEJ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;;;;IAKI;;AAEJ;IACI,YAAY;AAChB;;;AAGA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;IAEnB;QACI;YACI,WAAW;YACX,cAAc;YACd,UAAU;YACV,mCAAmC;YACnC,iBAAiB;YACjB,YAAY;QAChB;IACJ;AACJ;;AAEA;;;;GAIG;;;AAGH;IACI,uBAAuB;AAC3B;;AAEA;;;;GAIG;;AAEH,+BAA+B;;AAE/B;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,4CAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mCAAmC;IACnC,oCAAoC;IACpC,oCAAoC;IACpC,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mCAAmC;IACnC,oCAAoC;IACpC,+BAA+B;IAC/B,WAAW;IACX,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,YAAY;IACZ,eAAe;;AAEnB;;AAEA;;;GAGG;AACH;IACI,oCAAoC;IACpC,yGAAyG;AAC7G;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;AACA;;;;;;;;;GASG;;AAEH;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,aAAa;IACb,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,mBAAmB;IACnB,kBAAkB;;IAElB,8BAA8B;IAC9B,mBAAmB;IACnB,qDAAqD;IACrD,kCAAkC;IAClC,eAAe;IACf,iCAAiC;AACrC;;;AAGA,mCAAmC;;AAEnC;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,0BAA0B;IAC9B;AACJ;;;AAGA;IACI,qCAAqC;AACzC;;;AAGA;IACI;QACI;YACI;gBACI,gBAAgB;gBAChB,YAAY;YAChB;QACJ;IACJ;AACJ;;;AAGA;IACI;QACI,kBAAkB;QAClB,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,OAAO;IACX;;IAEA;QACI,SAAS;QACT,2BAA2B;QAC3B,kBAAkB;IACtB;;IAEA,uBAAO,YAAY,CAAC;IACpB;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;;OAEG;;IAEH;QACI,kBAAkB;IACtB;;IAEA;QACI;YACI,WAAW;QACf;;QAEA,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,aAAa;QACb,YAAY;QACZ,2BAA2B;QAC3B,0CAA0C;;IAE9C;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,SAAS;QACT,mBAAmB;QACnB,wBAAwB;QACxB,8BAA8B;QAC9B,mBAAmB;QACnB,+CAA+C;QAC/C,cAAc;QACd,kCAAkC;QAClC,eAAe;QACf,iCAAiC;IACrC;;AAEJ;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB;QACI,WAAW;QACX,UAAU;QACV,yBAAyB;QACzB,kBAAkB;IACtB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;;IAE7B;QACI,yBAAyB;;IAE7B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;;IAE7B,6BAA6B;IAC7B,iBAAiB;IACjB;QACI,WAAW;QACX,UAAU;QACV,sBAAsB;QACtB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,gBAAgB;;IAEpB;AACJ;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;AACA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".header {\n    align-items: center;\n    background-color: var(--background);\n    display: flex;\n    height: 66px;\n    justify-content: space-between;\n    padding: 20px 40px;\n    width: 100%;\n    z-index: var(--sidebar);\n}\n\n.searchBar {\n    height: 100%;\n    display: flex;\n    align-items: center;\n\n    position: relative;\n}\n\n.input {\n    color: var(--white);\n    padding: 15px;\n    height: 40px;\n    width: 457px;\n    border-radius: 5px;\n    border: 1px solid var(--white);\n\n    background-color: var(--black);\n    font-size: 1rem;\n    outline: none;\n}\n\n.searchIcon {\n    background-color: var(--red);\n    height: 40px;\n    width: 40px;\n    border-radius: 0 5px 5px 0;\n    right: 0;\n    position: absolute;\n\n}\n\ninput::placeholder {\n    color: var(--white);\n    font-size: 1rem;\n\n}\n\ninput:focus {\n    outline: none;\n}\n\n@media screen and (max-width: 1239px) {\n    .header::after {\n        width: calc(100% - var(--width-tablet-sidebar));\n    }\n    .header {\n        padding: 15px 20px;\n        position: relative;\n        height: 60px;\n    }\n    \n}\n\n.burger img {\n    width: 30px;\n    height: 30px;\n}\n\n/* .logo {\n    height: 100%;\n    justify-content: center;\n    display: flex;\n    line-height: 30px;\n}  */\n\n.logo img{\n    height: 24px;\n}\n\n\n.navlist {\n    align-items: center;\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 20px;\n    justify-content: center;\n}\n\n.navlist li {\n    position: relative;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    &:not(:last-child) {\n        &:after {\n            content: '';\n            display: block;\n            width: 1px;\n            background-color: var(--disabled-c);\n            margin-left: 20px;\n            height: 28px;\n        }\n    }\n}\n\n/* .separator {\n    border-right: 1px solid #ffffff;\n    height: 18px;\n    margin: 0 10px;\n} */\n\n\n.header:has(.mobile_logo:only-child) {\n    justify-content: center;\n}\n\n/* .icon {\n    background-color: #000000;\n    height: 50px;\n\n} */\n\n/* --------Contacts---------- */\n\n.user_acconts {\n    position: relative;\n}\n\n.container {\n    display: block;\n    height: max-content;\n    width: max-content;\n    position: absolute;\n    top: 35px;\n    right: -18px;\n    background-color: #ffffff;\n    border: 1px solid var(--red);\n    border-radius: 5px;\n    padding: 10px;\n    animation: menuslider 0.5s ease-in;\n    z-index: var(--cross);\n}\n\n.user_acconts .container {\n    right: -25px;\n    padding: 1.2vw;\n}\n\n.container li {\n    color: black;\n}\n\n.exit {\n    /*font-size: 12px;*/\n    margin: 16px;\n    text-align: center;\n}\n\n\n.container a {\n    color: #000000;\n}\n\n.container:before {\n    content: \"\";\n    position: absolute;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-bottom: 10px solid var(--red);\n    right: 20px;\n    top: -10px;\n}\n\n.container:after {\n    content: \"\";\n    position: absolute;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-bottom: 10px solid white;\n    right: 20px;\n    top: -8px;\n}\n\n.user_acconts li {\n    padding: 5px 0;\n}\n\n.user_acconts li:not(:last-child) {\n    border-bottom: 1px solid rgba(231, 49, 39, 0.4);\n}\n\n.account_btn {\n    text-align: left;\n    padding: 15px;\n    color: var(--black);\n    width: 100%;\n    font-size: 12px;\n    line-height: 1.5;\n    margin-bottom: 5px;\n}\n\n.account_btn:disabled {\n    color: var(--black);\n    background-color: var(--ghost-white);\n    border: none;\n    cursor: default;\n\n}\n\n/* .account_btn:hover {\n    background-color: var(--disabled-bg);\n    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1);\n} */\n.boxAccount:hover {\n    background-color: var(--disabled-bg);\n    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.account_btn > p {\n    color: var(--dark-gray);\n    font-size: 14px;\n}\n/* .account_btn {\n    span {\n        font-size: 10px;\n        display: inline-block;\n        color: var(--roman-silver);\n        width: 100px;\n        margin-left: -110px;\n        margin-right: 7px;\n    }\n} */\n\n.modalWrapper {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100vh;\n    width: 100vw;\n    z-index: var(--modal-layer);\n}\n\n.headerPopup {\n    position: absolute;\n    right: 39px;\n    top: 70px;\n    height: max-content;\n    width: max-content;\n\n    background-color: var(--white);\n    border-radius: 10px;\n    box-shadow: 0px 4px 16px 0px rgba(141, 155, 184, 0.2);\n    /* padding: 15px 20px 20px 20px; */\n    font-size: 12px;\n    font-family: 'Mulish', sans-serif;\n}\n\n\n/* ------------------------------ */\n\n@keyframes menuslider {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n\n    50% {\n        opacity: 1;\n        transform: translateY(0px);\n    }\n}\n\n\n.user_acconts button {\n    transition: transform .2s ease-in-out;\n}\n\n\n@media screen and (max-width: 1239px) {\n    .navlist li {\n        &:not(:last-child) {\n            &:after {\n                margin-left: 6px;\n                height: 26px;\n            }\n        }\n    }\n}\n\n\n@media screen and (max-width: 767px) {\n    .header {\n        padding: 13px 20px;\n        position: relative;\n        height: 50px;\n    }\n\n    .header::after {\n        width: 100%;\n        left: 0;\n    }\n\n    .navlist {\n        gap: 10px;\n        z-index: var(--modal-layer);\n        position: relative;\n    }\n\n    .logo {height: 100%;} \n    .logo img {\n        height: 24px;\n        width: auto;\n    }\n    \n    /* .separator {\n        margin: 0 5px;\n    } */\n\n    .line {\n        padding: 10px 20px;\n    }\n\n    .burger {\n        img {\n            width: 27px;\n        }\n\n        z-index: var(--over-modal);\n    }\n\n    .modalWrapper {\n        position: absolute;\n        left: 0;\n        top: 0;\n        height: 100vh;\n        width: 100vw;\n        z-index: var(--modal-layer);\n        background-color: rgba(126, 150, 191, 0.6);\n        \n    }\n\n    .headerPopup {\n        position: absolute;\n        left: 0;\n        top: 50px;\n        height: max-content;\n        width: calc(100% - 40px);\n        background-color: var(--white);\n        border-radius: 10px;\n        /* box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px; */\n        margin: 0 20px;\n        /* padding: 15px 20px 20px 20px; */\n        font-size: 12px;\n        font-family: 'Mulish', sans-serif;\n    }\n\n}\n\n@media screen and (max-device-width: 470px) {\n    .navlist {\n        gap: 6px;\n    }\n}\n\n.etc {\n    min-width: 24px;\n    height: 24px;\n    display: flex;\n    gap: 2px;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px;\n    border: 1px solid black;\n    margin-left: 20px;\n    div {\n        height: 3px;\n        width: 3px;\n        background-color: #000000;\n        border-radius: 50%;\n    }\n}\n\n.etc:hover {\n    background-color: var(--blue);\n    border: 1px solid var(--blue);\n\n    div {\n        background-color: #ffffff;\n\n    }\n}\n\n.etcActive {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    gap: 2px;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px;\n    background-color: var(--blue);\n\n    border: 1px solid var(--blue);\n    margin-left: 20px;\n    div {\n        height: 3px;\n        width: 3px;\n        background-color: #fff;\n        border-radius: 50%;\n    }\n}\n@media screen and (max-width: 767px) {\n    .etcActive, .etc {\n        margin-left: 5px;\n\n    }\n}\n\n.avatar {\n    background: var(--blue);\n    border-radius: 50%;\n    background-size: cover;\n    height: 35px;\n    line-height: 35px;\n    text-align: center;\n    width: 35px;\n    color: #fff;\n}\n.avatarCompany {\n    background: var(--sidebar-hover);\n    border-radius: 50%;\n    height: 35px;\n    line-height: 35px;\n    text-align: center;\n    width: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `fu5wPeEeY19JO5Ykvtt9`,
	"searchBar": `bQa_fAmZf1KDuNsNogB_`,
	"input": `f_HStgEbqF8uEoloYc5g`,
	"searchIcon": `XMTRqCU4Jr92kTqOxDgI`,
	"burger": `wUkz9Q3hUWnLgBdhdOHW`,
	"logo": `VJP9lm7KKyFsMjoSw_Ti`,
	"navlist": `KG8t9r0EQtTkcWJvrR3h`,
	"mobile_logo": `V4XMHjEUPMsytMfTBauu`,
	"user_acconts": `GAyIo3_TQQzadlwNe9a4`,
	"container": `Pe_Qka6g65LnVGsMOBcr`,
	"menuslider": `OCsXhj9eqh9SMfOD_AwG`,
	"exit": `kzaDABW_0ZVDZmc9g59c`,
	"account_btn": `Yy22RLA6hpl904go6A7c`,
	"boxAccount": `DUPVMUlR_DCmNkLUSeFh`,
	"modalWrapper": `uwn83KQPrGSWGKByu_ag`,
	"headerPopup": `hZ3lEAhTpIU8uUCoxuaR`,
	"line": `v57lTLlGvUxxurhULUaw`,
	"etc": `QCnYunaonDzpGiXIVKGw`,
	"etcActive": `yKnaWNK8TqJFHIJdGtg3`,
	"avatar": `z3XYrQQiWN_spfpuOsVy`,
	"avatarCompany": `rOr3vTmHw3uLy4VUwAJz`
};
export default ___CSS_LOADER_EXPORT___;
